import { render, staticRenderFns } from "./Pazarama.vue?vue&type=template&id=9d86de72&scoped=true"
import script from "./Pazarama.vue?vue&type=script&lang=js"
export * from "./Pazarama.vue?vue&type=script&lang=js"
import style0 from "./Pazarama.vue?vue&type=style&index=0&id=9d86de72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d86de72",
  null
  
)

export default component.exports